import { useEffect, useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';

import { MasterTab } from '../MasterTab';
import { deleteDataWithParameters, getAllDetails, getAllDetailsDirect, postAllData } from '../../../service/ProductService';
import { UNIVERSITY, UPDATE_UNIVERSITY } from '../../../config/ApiConstant';
import { SkeletonbodyTemplate, Skeletonitems, defaultPageRowOptions, defaultRowOptions, paginatorLinks, showingEntries } from '../../../appconfig/Settings';
import { UniversityMasterListColumns } from '../../../appconfig/DatatableSetting';
import { Dialog } from 'primereact/dialog';
import { AddUniversityMasterValidate } from '../../../config/Validate';
import { InputTextarea } from 'primereact/inputtextarea';
import { useNavigate } from 'react-router-dom';

export const UniversityMaster = () => {
    document.title = 'University Master | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    const navigate = useNavigate();

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [addUniversityMaster, setAddUniversityMaster] = useState<any>({});
    const [universityList, setUniversityList] = useState<any>([]);

    const [addUpdateLoader, setAddUpdateLoader] = useState<boolean>(false);
    const [addUpdateModal, setAddUpdateModal] = useState<boolean>(false);
    const [editId, setEditId] = useState<any>(null);
    const [errors, setErrors] = useState<any>({});
    const [deleteModal, setDeleteModal] = useState<boolean>(false);
    const [deleteId, setDeleteId] = useState<any>(null);
    const [deleteLoader, setDeleteLoader] = useState<boolean>(false);

    // useEffect
    useEffect(() => {
        getUniversityMasterList();
    }, []);

    //onchange event
    const onInputChange = (e: any, name: string) => {
        let val = (e.target && e.target.value) || e.value || '';

        setAddUniversityMaster({ ...addUniversityMaster, [name]: val });
    };

    const rightToolbarTemplate = () => {
        return (
            <>
                <Button label="Add University " icon="pi pi-plus" className="p-button" onClick={() => openAddModal()} />
                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAllFilter()} className="p-button-outlined ml-3"></Button>
            </>
        );
    };

    //Clear All Filter
    const clearAllFilter = () => {
        setGlobalFieldFilter(null);
        setGlobalFilter(null);
    };

    const leftToolbarTemplate = () => {
        return (
            <>
                <span className="search-bar">
                    <i className="pi pi-search"></i>
                    <InputText type="search" className="search-input" onInput={(e) => setGlobalFilter(e.currentTarget.value)} placeholder="Search..." />
                </span>
            </>
        );
    };

    // Get universityList list
    const getUniversityMasterList = async () => {
        try {
            setPageLoad(false);
            const response = await getAllDetailsDirect(UNIVERSITY);
            if (response) {
                const DataList: any = response;
                if (DataList.length === 0) {
                    setUniversityList([]);
                } else {
                    setUniversityList(DataList);
                }
                setPageLoad(true);
            } else {
                setPageLoad(true);
                setUniversityList([]);
            }
        } catch (error: any) {
            if (error.response) {
                setPageLoad(true);
                setUniversityList([]);
                toast.current?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Sorry Could Not Load Data'
                });
            }
        }
    };

    // Open add modal
    const openAddModal = () => {
        setAddUpdateModal(true);
    };

    // Close add modal
    const closeAddUpdateModal = () => {
        setAddUniversityMaster({});
        setEditId(null);
        setAddUpdateLoader(false);
        setAddUpdateModal(false);
        setErrors({});
    };

    // Open edit modal
    const openEditModal = (rowData: any) => {
        setEditId(rowData?.SrNo);
        setAddUniversityMaster({
            UName: rowData?.UName,
            Uadd: rowData?.Uadd
        });
        setAddUpdateModal(true);
    };

    // Open delete modal
    const openDeleteModal = (index: any) => {
        setDeleteId(index);
        setDeleteModal(true);
    };

    // Close delete modal
    const closeDeleteModal = () => {
        setDeleteId(null);
        setDeleteModal(false);
    };

    // Template for action
    const actionsTemplate = (rowData: any) => {
        return (
            <>
                <div className="flex">
                    <Button icon="pi pi-pencil" tooltip="Edit" tooltipOptions={{ position: 'top' }} className="p-button-rounded" onClick={() => openEditModal(rowData)} />
                    <Button icon="pi pi-trash" tooltip="Delete" tooltipOptions={{ position: 'top' }} className="p-button-danger p-button-rounded ml-2" onClick={() => openDeleteModal(rowData?.SrNo)} />
                </div>
            </>
        );
    };

    // On submit add update app
    const onSubmitAddUpdateApp = async () => {
        try {
            const { errors, isError } = AddUniversityMasterValidate(addUniversityMaster);
            setErrors(errors);
            //Check Error if no errors then call API
            if (!isError) {
                setAddUpdateLoader(true);
                //URL
                let apiUrl = UNIVERSITY;
                //Request object
                const requestData: any = addUniversityMaster;

                if (!window.cn(editId)) {
                    requestData['SrNo'] = editId;
                    apiUrl = UPDATE_UNIVERSITY;
                }
                //apicall
                const response = await postAllData(apiUrl, requestData);
                if (response && !window.cn(response)) {
                    setEditId(null);
                    setAddUniversityMaster({});
                    setAddUpdateLoader(false);
                    toast.current?.show({ severity: 'success', summary: 'Success', detail: response?.message });
                    setTimeout(() => {
                        setAddUpdateModal(false);
                        getUniversityMasterList();
                    }, 1000);
                }
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setAddUpdateLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    // Delete application
    const deleteApplication = async () => {
        try {
            setDeleteLoader(true);
            // Delete api call
            const response = await deleteDataWithParameters(UNIVERSITY + '?SrNo=' + deleteId);
            if (response) {
                setDeleteLoader(false);
                setDeleteModal(false);
                setDeleteId(null);
                toast.current?.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: response?.data
                });
                setTimeout(() => {
                    getUniversityMasterList();
                }, 1500);
            } else {
                toast.current?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Something went wrong, Please try again.'
                });
                setDeleteLoader(false);
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setDeleteLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    return (
        <>
            <MasterTab mainTabLabel="University Master" />
            <Toast ref={toast} />
            <div className="grid crud-demo mt-3">
                <div className="col-12">
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={universityList}
                                    showGridlines
                                    stripedRows
                                    className="datatable-responsive"
                                    emptyMessage="No Data Found"
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    rows={defaultRowOptions}
                                    paginator={universityList.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    paginatorTemplate={paginatorLinks}
                                    currentPageReportTemplate={showingEntries}
                                    removableSort
                                >
                                    {UniversityMasterListColumns.map((col, i) => {
                                        if (col.field === 'action') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={actionsTemplate} />;
                                        } else if (col.field === 'sr_no') {
                                            return <Column key={col.field} header={col.header} body={(_, { rowIndex }) => rowIndex + 1} style={{ minWidth: '5rem' }} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {UniversityMasterListColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {/* Add Update Dialog */}
            <Dialog
                visible={addUpdateModal}
                className="p-fluid"
                style={{ width: '550px' }}
                header={editId !== null ? 'Edit University Data' : 'Add University Data'}
                modal
                draggable={false}
                resizable={false}
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={closeAddUpdateModal} />
                        <Button label="Submit" icon="pi pi-check" className="p-button-primary" onClick={() => onSubmitAddUpdateApp()} loading={addUpdateLoader} />
                    </>
                }
                onHide={closeAddUpdateModal}
            >
                <div className="formgrid grid">
                    <div className="field col-12 md:col-12">
                        <label htmlFor="UName">
                            University Name <span style={{ color: 'red' }}>*</span>
                        </label>
                        <div className="input-effect-div">
                            <InputText value={addUniversityMaster?.UName} name="UName" autoComplete="off" placeholder="Enter College Name" onChange={(e) => onInputChange(e, 'UName')} className={errors['UName'] && 'p-invalid'} />
                            <span className="focus-bg"></span>
                        </div>

                        <small className="p-invalid-txt">{errors['UName']}</small>
                    </div>

                    <div className="field col-12 md:col-12">
                        <label htmlFor="Uadd">
                            Address <span style={{ color: 'red' }}>*</span>
                        </label>
                        <div className="input-effect-div">
                            <InputTextarea rows={4} value={addUniversityMaster?.Uadd} name="Uadd" autoComplete="off" placeholder="Enter Address" onChange={(e) => onInputChange(e, 'Uadd')} className={errors['Uadd'] && 'p-invalid'} />
                            <span className="focus-bg"></span>
                        </div>
                        <small className="p-invalid-txt">{errors['Uadd']}</small>
                    </div>
                </div>
            </Dialog>

            {/* Delete Dialog */}
            <Dialog
                visible={deleteModal}
                style={{ width: '450px' }}
                header="Delete University"
                modal
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={closeDeleteModal} />
                        <Button label="Delete" icon="pi pi-trash" className="p-button-danger" onClick={deleteApplication} loading={deleteLoader} />
                    </>
                }
                onHide={closeDeleteModal}
            >
                <div className="flex align-items-center justify-content-start">
                    <i className="pi pi-exclamation-triangle mr-3 delete-triangle" style={{ fontSize: '2rem' }} />
                    <span className="delete-dialog-note">Note: Once you delete this University, This will be deleted permentatly.</span>
                </div>
            </Dialog>
        </>
    );
};
